import { NgModule } from '@angular/core';
import { ArmedPaxCardComponent } from './armed-pax-card/armed-pax-card.component';
import { SharedModule } from '@shared/modules/shared.module';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [ArmedPaxCardComponent],
  imports: [CommonModule, SharedModule],
  exports: [ArmedPaxCardComponent],
})
export class ArmedPaxModule {}
